module.exports = __webpack_public_path__ + "img/deserted-court-yard-unknown.77954e6d.jpg";